import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";

import { default as driver1 } from "../../assets/rewards/reward-driver-1.png";
import { default as driver2 } from "../../assets/rewards/reward-driver-2.png";
import { default as driver3 } from "../../assets/rewards/reward-driver-3.png";
import { default as team1 } from "../../assets/rewards/reward-team-1.png";
import { default as team2 } from "../../assets/rewards/reward-team-2.png";
import { default as team3 } from "../../assets/rewards/reward-team-3.png";

const imgMap = {
  driver1,
  driver2,
  driver3,
  team1,
  team2,
  team3,
};

const getTitleText = (item) => {
  return `${item.name} - ${item.at}`;
};

const getAchievementImage = (type, position) => {
  return imgMap[`${type}${position}`];
};

const CenteredImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledImage = styled.img`
  width: 50px;
`;

const AchievementsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const GroupTitle = styled.div`
  font-size: 13px;
  text-align: center;
  color: #67676d;
  margin-top: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
`;

const Title = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: bold;
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Achievements = ({ driverAchievements = [], teamAchievements = [] }) => {
  if (!driverAchievements.length && !teamAchievements.length) return <></>;

  return (
    <>
      <Title>Досягнення</Title>
      {driverAchievements.length > 0 && (
        <>
          <GroupTitle>Особисті нагороди</GroupTitle>
          <AchievementsContainer>
            {driverAchievements.map((item) => {
              return (
                <Tooltip title={getTitleText(item)} arrow placement="top">
                  <CenteredImageContainer>
                    <StyledImage
                      src={getAchievementImage("driver", item.place)}
                      alt={`${item.place} place`}
                    />
                  </CenteredImageContainer>
                </Tooltip>
              );
            })}
          </AchievementsContainer>
        </>
      )}
      {teamAchievements.length > 0 && (
        <>
          <GroupTitle>Командні нагороди</GroupTitle>
          <AchievementsContainer>
            {teamAchievements.map((item) => {
              return (
                <Tooltip title={getTitleText(item)} arrow placement="top">
                  <CenteredImageContainer>
                    <StyledImage
                      src={getAchievementImage("team", item.place)}
                      alt={`${item.place} place`}
                    />
                  </CenteredImageContainer>
                </Tooltip>
              );
            })}
          </AchievementsContainer>
        </>
      )}
    </>
  );
};

export default Achievements;
